export class MensagemConst {

    public static GERACAO_PRE_PEDIDO = 'Pré-pedido Gerado com sucesso!!!';
    public static EXCLUIR_COTACAO = "Informações Excluídas com Sucesso!!!";
    public static EXCLUIR_FORNECEDOR = "Informações Excluídas com Sucesso!!!";
    public static FECHAR_COTACAO = "Fechamento das cotações realizados com sucesso!";
    public static REABRIR_COTACAO = "Reabertura das cotações realizados com sucesso!";
    public static MSGSAVEUPOK = "Informações Salvas com Sucesso!!!";
    public static MSGDELETEOK = "Informações Excluídas com Sucesso!!!";
    public static MSGSAVEUPNAOOK = "Não foi possível Salvar Informações!!!";
    public static MSGDELETENAOOK = "Não foi possível Excluir Informações!!!";
    public static MSGSESSAONAOOK = "SessaoExpirada";
    public static MSGGERACAOPREPEDIDO = "Pré-pedido Gerado com sucesso!!!";
    public static MSGGERACAOPREPEDIDONAOOK = "Não foi possível Gerar pré-pedido!!!";    

}
